<script>
  import { project } from "$lib/services/store";

  export let data = null;
</script>

<svelte:head>
  <title>Sitemap for {$project.name}</title>
  <meta name="description" content={ "A map of the website for " + $project.name + ". Links to all the posts included." } />
</svelte:head>

<div class="single-page">
  <div class="block block-sitemap-page">
    <div class="container">
      <div class="row">
        <h1>Sitemap for {$project.name}</h1>
        {#if data.allPosts.length}
          <ul>
            {#each data.allPosts as post}
              <li class:child-page={ post.slug.split('/').length > 2 }><a href={ post.slug }>{ post.title }</a></li>
            {/each}
          </ul>
        {/if}
      </div>
    </div>
  </div>
</div>

<style>
  .block-sitemap-page ul {
    list-style: square;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin: 0;
    padding: 0 1.25rem;
  }
  .block-sitemap-page ul li {
    grid-column: 1 / 5;
  }
  .block-sitemap-page ul li.child-page {
    list-style: inside;
    grid-column: auto;
  }
  .block-sitemap-page ul li.child-page a {
    font-size: 0.825rem;
  }

  li.child-page + :not(li.child-page) {
    margin: 1rem 0 0 0;
  }
</style>